import React, { useState, useEffect, useRef } from "react";
import { getCategories } from "../../../services/categoriesService";
import "../../../css/professionselect.css";

const ProfessionSelect = ({ options = [], accountType, onSelect }) => {
    const [items, setItems] = useState([]);
    const [search, setSearch] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selected, setSelected] = useState(null);

    const BUSINESS_EXCLUDED = ["General Worker", "Handyman"];

    const ref = useRef();

    useEffect(() => {
        const isBusiness =
            accountType?.toLowerCase().trim() === "business";

        const filtered = isBusiness
            ? options.filter(
                (item) => !BUSINESS_EXCLUDED.includes(item.label) // Fixed: item.label instead of item.name
            )
            : options;

        setItems(filtered);
    }, [options, accountType]);

   
    // Fixed: changed item.name to item.label
    const filteredItems = items.filter((item) =>
        item.label?.toLowerCase().includes(search.toLowerCase())
    );

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownOpen && ref.current && !ref.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownOpen]);

    const handleSelect = (item) => {
        setSelected(item);
        setSearch(item.label); // Fixed: item.label instead of item.name
        onSelect(item);
        setDropdownOpen(false);
    };

    return (
        <div className="profession-select" ref={ref}>
            <div className="select-input">
                <input
                    type="text"
                    placeholder="Service category"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onFocus={() => setDropdownOpen(true)}
                />

                {selected ? (
                    <span
                        className="clear-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelected(null);
                            setSearch("");
                        }}
                    >
                        ×
                    </span>
                ) : (
                    <span
                        className="arrow"
                        onClick={(e) => {
                            e.stopPropagation();
                            setDropdownOpen((prev) => !prev);
                        }}
                    >
                        {dropdownOpen ? "▾" : "▴"}
                    </span>
                )}
            </div>

            {dropdownOpen && (
                <ul className="dropdown-list drop-up">
                    {filteredItems.map((item) => (
                        <li
                            key={item.value} // Fixed: item.value instead of item.id
                            className="dropdown-item"
                            onClick={() => handleSelect(item)}
                        >
                            {item.label} {/* Fixed: item.label instead of item.name */}
                        </li>
                    ))}

                    {filteredItems.length === 0 && (
                        <li className="dropdown-item no-results">No results</li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default ProfessionSelect;